import { z } from 'zod';

/**
 * Wire schemas for `GET/POST/DELETE /invoices/:id/comments` (#50, REQ3.6).
 *
 * Body is markdown text. The frontend renders it through a tiny
 * allow-list renderer (`apps/web/src/lib/markdown.ts`) so the wire format
 * stays plain text - no HTML round-trip, no XSS surface in the API.
 *
 * Audit (REQ8.1, REQ9.5): the route handler emits `invoice.comment.create`
 * and `invoice.comment.delete` audit rows; this is enforced by the route
 * layer, not the schema.
 */

/** Single comment as returned by `GET /invoices/:id/comments`. */
export const InvoiceCommentSchema = z.object({
  id: z.string(),
  invoiceId: z.string(),
  authorId: z.string(),
  authorEmail: z.string(),
  body: z.string(),
  createdAt: z.string().datetime(),
});
export type InvoiceComment = z.infer<typeof InvoiceCommentSchema>;

export const InvoiceCommentListResponseSchema = z.object({
  items: z.array(InvoiceCommentSchema),
});
export type InvoiceCommentListResponse = z.infer<typeof InvoiceCommentListResponseSchema>;

/**
 * Create payload. The body is bounded so a single comment cannot blow up
 * the row. 4_000 chars matches a generous Markdown comment - well under
 * SQLite TEXT limits and over typical operator notes.
 */
export const CreateInvoiceCommentRequestSchema = z.object({
  body: z.string().min(1).max(4000),
});
export type CreateInvoiceCommentRequest = z.infer<typeof CreateInvoiceCommentRequestSchema>;

export const CreateInvoiceCommentResponseSchema = InvoiceCommentSchema;
export type CreateInvoiceCommentResponse = z.infer<typeof CreateInvoiceCommentResponseSchema>;
